<template>
  <div>
    <p class="text-center text-sm"><button type="button" class="bt clear" @click="showModal()">{{ trans('products.add_to_wishlist') }}</button></p>

    <the-modal
      class="pt-12 lg:pt-0"
      modal-width="extrasmall"
      @close="modalShown = false"
      v-if="modalShown">
      <div class="flex flex-row items-center bg-gray-200 leading-none py-2 px-4" slot="header">
        <div class="flex-1">Agregar a lista de desesos</div>
        <div class="flex-none ml-2 cursor-pointer hover:text-main" @click="modalShown = false"><action-icons icon="close" /></div>
      </div>
      <div slot="body">
        <div v-if="addingStatus == 'loading'" class="text-center text-sm text-gray-700 py-4">Guardando...</div>
        <form
          action="#"
          autocomplete="off"
          class="p-6 text-sm"
          @submit.prevent="addToWishList"
          v-else>

          <div v-if="addingStatus == 'success'" class="alert success mb-4">Agregado a la lista</div>
          <div v-if="addingStatus == 'already-added'" class="alert success mb-4">La lista de deseos ya tiene este producto.</div>
          <div v-if="addingStatus == 'error'" class="alert danger mb-4">Lo sentimos, no pudimos agregar el producto. Por favor, intenta nuevamente.</div>

          <div class="text-gray-700 text-center" v-if="wishlists.length == 0">Aún no has creado ninguna lista de deseos.<br><a href="/auth/mi-cuenta" class="link-basic text-main">Crear una</a></div>
          <template v-else>
            <div class="bordered-list">
              <div
                class="item light py-1 mb-1"
                :key="`wishlist-${list.uuid}`"
                v-for="list in wishlists">
                <label class="cursor-pointer hover:text-main"><input type="radio" v-model="selectedList" :value="list.uuid" /> {{ list.name }}</label>
              </div>
            </div>
            <p class="text-center mt-4"><button :class="selectedList == '' ? 'disabled' : 'main'" class="bt md">Agregar</button></p>
          </template>

        </form>
      </div>
      <div slot="footer"></div>
    </the-modal>
    
    <the-modal
      class="pt-12 lg:pt-0"
      modal-width="extrasmall"
      @close="loginModalShow = false"
      v-if="loginModalShow">
      <div class="flex flex-row items-center bg-gray-200 leading-none py-2 px-4" slot="header">
        <div class="flex-1">Agregar a lista de desesos</div>
        <div class="flex-none ml-2 cursor-pointer hover:text-main" @click="loginModalShow = false"><action-icons icon="close" /></div>
      </div>
      <div slot="body" class="p-6 text-center text-sm">Para agregar productos a tus listas de deseos, primero debes <a href="/login" class="text-main link-basic">Iniciar sesión</a></div>
      <div slot="footer" class="py-2"></div>
    </the-modal>
  </div>
</template>
<script>
export default {
  name: 'add-to-wishlist',
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    wishlists: {
      type: Array,
      default() {
        return []
      }
    },
    product: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalShown: false,
      loginModalShow: false,
      addingStatus: '',
      selectedList: '',
    }
  },
  methods: {
    showModal() {
      if (this.isLoggedIn) {
        this.modalShown = true;
      } else {
        this.loginModalShow = true;
      }
    },
    addToWishList() {
      if (this.selectedList == '') {
        return;
      }

      this.addingStatus = 'loading';
      axios.post(
        `/auth/wishlists/${this.selectedList}/add-product`,
        { product: this.product }
      )
      .then(response => {
        this.addingStatus = 'success';

        setTimeout(() => {
          this.modalShown = false;
        }, 1000);
      })
      .catch(error => {
        if (error.response.status == 409) {
          this.addingStatus = 'already-added';
        } else {
          this.addingStatus = 'error';
        }
      });
    }
  }
}
</script>